import React, { useEffect, useRef, useState } from 'react'
import { Button, Header, Input } from '../../components'
import { BsPlusCircleFill, BsTrash } from 'react-icons/bs';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axiosClient from '../../axios-client';
import Loading from '../../components/Loading';
import { useStateContext } from '../../contexts/ContextProvider';
import { AiTwotoneEdit } from 'react-icons/ai';
import ActionButton from '../../components/ActionButton';
import { MdOutlineAccountBalanceWallet } from "react-icons/md";
import { IoIosSearch } from 'react-icons/io';
import Select from 'react-select';
import { DownloadTableExcel } from 'react-export-table-to-excel';
import { FaCheckCircle, FaEdit, FaEye, FaRegFileExcel } from 'react-icons/fa';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import AddDevoir from './AddDevoir';
import Alert from '../../components/Alert';
import EditDevoir from './EditDevoir';
import { TbPencilCheck, TbPencilStar } from 'react-icons/tb';
import { GiCancel } from 'react-icons/gi';
import { FaFeatherPointed } from 'react-icons/fa6';
import { PiNotePencilBold } from 'react-icons/pi';
import { RiEmotionHappyFill, RiEmotionUnhappyFill } from 'react-icons/ri';
import EditNoteDevoir from './EditNoteDevoir';
import TabHead from '../../components/TabHead';
import MySelect from '../../components/MySelect';

const FastNotes = ({ selectedDevoir, onClose }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState(null);
  const { setToken, user } = useStateContext();




  const [eleves, setEleves] = useState([]);


  const tableRef = useRef(null);

  // Stockage des notes sous forme {id: note}
  const [notes, setNotes] = useState({});

  // Tableau de références pour chaque input
  const inputRefs = useRef([]);

  // Mise à jour d'une note d'élève
  const handleChange = (id, value) => {
    setNotes((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Enter") {
      e.preventDefault(); // empêcher saut de ligne

      const nextInput = inputRefs.current[index + 1];
      if (nextInput) {
        nextInput.focus(); // aller au prochain input
      }
    }
  };

  const erreurSaisie = () => {
    Swal.fire({
      title: 'Erreur!',
      text: 'Note ne peut pas être inférieure à 0 ou supérieure à '+selectedDevoir.noteMax,
      icon: 'error',
      confirmButtonText: 'OK'
    })
  }

  // Construction du tableau final à envoyer
  const enregistrerNotes = () => {
    const dataToPost = Object.entries(notes).map(([id, note]) => ({
      eleveId: id,
      note: Number(note),
    }));

    setErrors(null);
    setLoading(true);
    axiosClient.post('/noteDevoirBulk/save', {
      notes:dataToPost,
      devoirId:selectedDevoir.id
    })
      .then((response) => {
        setLoading(false);
        setErrors(null);
        toast.success('Opération effectuée avec succès!', {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
        onClose();
      }).catch(err => {
        const response = err.response;
        if (response.status === 401) {
          setToken(null);
        }
        else {
          if (response.status === 422) {
            setErrors(response.data.errors);
            setLoading(false);
            toast.error('Une erreur est survenue!', {
              position: "top-right",
              autoClose: 5000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: "light",
            });
          } else {
            if (response.status === 403) {
              navigate('/403');
            } else {
              if (response.status === 404) {
                navigate('/404');
              }
              else {
                navigate('/500');
              }
            }
          }

        }
      })

    console.log("Data POST :", dataToPost);
  };









  const getEleves = () => {
    axiosClient.get('/elevesNoteDe/' + selectedDevoir.id)
      .then((data) => {
        setEleves(data.data.eleves);
      }).catch(err => {
        navigate('/500');
      })
  }







  useEffect(() => {

    getEleves();
  }, []);
  return (
    <>
      <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
        <div className='h-screen flex justify-center items-center'>
          <div className='flex-col max-h-screen  overflow-y-auto bg-white py-12 px-7 w-auto md:w-1/2 lg:w-1/2 xl:w-1/2 rounded-xl'>
            <Header icon={<PiNotePencilBold />} category='Page' title={'Devoirs ' + selectedDevoir.classe.libelle + ' ' + selectedDevoir.matiereLibelle + ' / ' + selectedDevoir.trimestre.code} titleAr={selectedDevoir.classe.libelle + ' ' + selectedDevoir.matiereLibelle + ' / ' + selectedDevoir.trimestre.code + " إختبار"} />
            {errors &&
              Object.keys(errors).map(key => (
                <Alert key={key} message={errors[key][0]} />
              ))
            }
            <div className='flex-col '>
              
              <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap justify-between'>
                <div className="flex w-full flex-wrap md:flex-nowrap lg:flex-nowrap justify-end xl:flex-nowrap gap-2">
                  <div className='mt-8'>
                    {loading?<Loading/>:<Button onClick={enregistrerNotes} color="bg-green-500" icon={<FaFeatherPointed />} size="20" text="Noter" textColor="text-white" />}
                  </div>
                  
                  <div className='mt-8'>
                    <Button onClick={() => onClose()} color="bg-red-500" icon={<GiCancel />} size="20" text="Fermer" textColor="text-white" />
                  </div>
                </div>
              </div>

              <div className='mt-3 w-full overflow-x-auto'>
                <table ref={tableRef} className='table-auto'>
                  <thead>
                    <tr>
                      <th>Matricule</th>
                      <th>Élève</th>
                      <th>Note</th>
                    </tr>
                  </thead>
                  <tbody>
                    {eleves.map((eleve, index) => (
                      <tr key={eleve.id}>
                        <td>{eleve.matricule}</td>
                        <td>{eleve.eleve}</td>
                        <td>
                          <input
                            className='w-full'
                            type="number"
                            min={0}
                            max={selectedDevoir.noteMax}
                            placeholder={".../" + selectedDevoir.noteMax}
                            value={notes[eleve.id] || ""}
                            onChange={(e) => {
                              if (e.target.value < 0 || e.target.value > selectedDevoir.noteMax)
                                erreurSaisie();
                              else
                                handleChange(eleve.id, e.target.value)
                            }
                            }
                            onKeyDown={(e) => handleKeyDown(e, index)}
                            ref={(el) => (inputRefs.current[index] = el)}
                          />
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
        </div>


      </div>
    </>
  )
}

export default FastNotes